import { booleanAttribute, ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatCheckbox, MatCheckboxChange } from '@angular/material/checkbox';

@Component({
  selector: 'rp-table-checkbox',
  standalone: true,
  templateUrl: './table-checkbox.component.html',
  styleUrl: './table-checkbox.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatCheckbox],
})
export class TableCheckboxComponent {
  checked = input(false);
  indeterminate = input(false);
  disabled = input(false, {
    transform: booleanAttribute,
  });
  changed = output<MatCheckboxChange>();

  onChange(event: MatCheckboxChange) {
    this.changed.emit(event);
  }
}
